import React, { DetailedHTMLProps, forwardRef, HTMLAttributes } from 'react';
import classNames from 'classnames';

import styles from './Card.module.scss';

export interface ICardProps extends Omit<DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>, 'ref'> {
    rounded?: 'small' | 'medium' | 'large';
    direction?: 'row' | 'column';
    size?: 'small' | 'large';
    shadow?: 'medium';
    header?: React.ReactNode;
    footer?: React.ReactNode;
    bordered?: boolean;
    gap?: number;
}

export const Card = forwardRef<HTMLDivElement, ICardProps>(
    (
        {
            direction = 'column',
            rounded = 'large',
            size = 'large',
            gap = 16,
            className,
            bordered,
            children,
            shadow,
            header,
            footer,
            ...props
        },
        ref,
    ) => {
        return (
            <div
                ref={ref}
                className={classNames(
                    styles.card,
                    styles[`size-${size}`],
                    styles[`rounded-${rounded}`],
                    styles[`shadow-${shadow}`],
                    styles[`direction-${direction}`],
                    { [styles.bordered]: bordered },
                    className,
                )}
                {...props}
            >
                {header && <div className={styles.header}>{header}</div>}
                <div className={styles.content} style={{ gap }}>
                    {children}
                </div>
                {footer && <div className={styles.footer}>{footer}</div>}
            </div>
        );
    },
);
